import i18next from 'i18next';

/**
 * Column definitions for the Providers table.
 *
 * GET /accounts/{uuid}/providers supports filtering ONLY by name,
 * providerNPINumber, isLinked and isDefault, and sorting ONLY by name
 * and createdTimestamp — columns outside those sets carry no filter and
 * disableSorting. Boolean filters are intentionally NOT exposed as
 * column filters: the shared SELECT filter submits array values which
 * @shared/lib/endpoint.js base64-encodes, and this endpoint only accepts
 * plain URL-encoded filter values. isLinked/defaultStatus cell values
 * are pre-mapped to strings in the ProvidersTable widget (raw booleans
 * crash CellSimpleText's .split).
 */
export const PROVIDERS_COLUMNS = [
  {
    size: 260,
    header: i18next.t('providers:colName'),
    accessorKey: 'name',
    filter: {},
    enableHiding: false,
    isDefaultCell: true,
  },
  {
    size: 140,
    header: i18next.t('providers:colTitle'),
    accessorKey: 'providerTitle',
    disableSorting: true,
    isDefaultCell: true,
  },
  {
    size: 160,
    header: i18next.t('providers:colNpi'),
    accessorKey: 'providerNPINumber',
    filter: {},
    disableSorting: true,
    isDefaultCell: true,
  },
  {
    size: 140,
    header: i18next.t('providers:colLinked'),
    accessorKey: 'isLinked',
    disableSorting: true,
    isDefaultCell: true,
  },
  {
    size: 180,
    header: i18next.t('providers:colDefault'),
    accessorKey: 'defaultStatus',
    disableSorting: true,
    // One chip per context the provider is default for (PDF / Claims /
    // Assessments) — the widget pre-maps the isDefault{Context} flags
    // to a label array (+ raw keys in _rawValues for stable colors).
    cell: { withBubbles: true },
  },
  {
    size: 180,
    header: i18next.t('providers:colCreated'),
    accessorKey: 'createdTimestamp',
    isDefaultCell: true,
  },
];
